<template>
  <div class="fromItemContainer">
    <p v-if="imageUrl">Image</p>
    <div id="uploadImageContainer" v-if="!hideButtons && isEditable == true">
      <label class="file-select">
        <div class="select-button">
          <span v-if="uploadImage">Selected File: {{uploadImage.name}}</span>
          <span v-else>Upload Image</span>
        </div>
        <input type="file" @change="previewImage" accept="image/*" />
      </label>
      OR
      <div id="uploadImageInputContainer">
        <input
          id="uploadImageInput"
          v-model="imageUrl"
          @change="imageUrlInputHandler"
          placeholder="URL Image"
        />
        <img id="addIcon" src="../assets/Add@3x.png" />
      </div>
    </div>

    <div id="imageRestrictionsContainer" v-if="!hideButtons && isEditable == true">
      <div>
        Maximum file size:
        <span id="restrictionData">10MB</span>
      </div>
      <div>
        Allowed file types:
        <span id="restrictionData">JPG, PNG and GIF</span>
      </div>
      <div>
        Maximum dimensions:
        <span id="restrictionData">1032px by 1032px</span>
      </div>
    </div>
        <div v-if="imageError" style="text-align: left;background-color:rgba(235, 30, 47, 0.15); margin-top:15px; width: 100%; height:48px; border: 1px solid #EB1E2F; border-radius: 5px; display:block">
                <img style="width: 20px; margin-top:1.1%; margin-left:10px; height: 20px;top: 564px;" src="../assets/info.png">
                <p style="font-family: Roboto;
                margin-left: 40px;
                margin-top: -19.5px !important;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #EB1E2F;">The image you are trying to upload exceeds the maximum file dimensions</p>
      </div>
    <div id="imageUrlPreviewContainer" v-if="showImagePreview">
      <img style="margin-right:20px" id="imagePreview" v-bind:src="this.imageUrl" />
      <div id="imagePreviewInfo">
        <div>{{this.imageHeight}}KB</div>
        <div>        {{this.imageUrl}}</div>
        <div id="deleteImageBtn" v-on:click="deleteImageUrl" v-if="isEditable == true">Delete Image</div>
      </div>
    </div>
    <div id="imagePreviewContainer" v-if="imageData">
      <img id="imagePreview" :src="uploadImage" />
      <div id="uploadPreviewInfo">
        {{this.imageUrl}}
        <p  v-if="uploadImage == null">
          Progress: {{uploadValue.toFixed()+"%"}}
          <progress
            id="progress"
            :value="uploadValue"
            max="100"
          ></progress>
        </p>
        <!-- <div id="uploadImageBtn" v-on:click="onUpload" v-if="isEditable == true">Upload</div> -->
        <div id="deleteImageBtn" v-on:click="deleteImageUrl" v-if="isEditable == true">Delete Image</div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "FormBody",
  data() {
    return {
      uploadImage: null,
      imageData: null,
      uploadValue: 0,
      imageUrl: "",
      imageSize: null,
      showImagePreview: false,
      hideButtons: false,
      imageError: false
    };
  },
  props: {
    startData: Object,
    isEditable: Boolean,
  },
  computed: {
    showCalendarDate: {
      get() {
        var date = this.date.getUTCDate();
        var month = this.date.getUTCMonth() + 1;
        var year = this.date.getUTCFullYear();
        return date + "/" + month + "/" + year;
      },
    },
  },
  methods: {
    async imageUrlInputHandler() {
      this.imageError = false;
      this.hideButtons = true;
      if (this.imageUrl === null || this.imageUrl === "") {
        this.showImagePreview = false;
      } else {
         var img = new Image();
        img.src = this.imageUrl;
        img.onload = evt => { 
          if (evt.path){
            if(evt.path[0].width > 1032 || evt.path[0].height > 1032 || evt.path[0].size > 10000000){
              this.imageUrl = null;
              this.imageError = true;
              this.showImagePreview = false;
            }
          }
          }

        this.$emit("imageUrlResult", this.imageUrl);
        this.showImagePreview = true;

        let response = await fetch(this.imageUrl);
        let data = await response.blob();
        let metadata = {
          type: "image/jpeg",
        };
        let file = new File([data], "test.jpg", metadata);
        this.imageSize = file.size;
        console.log("IMAGEN",file)
      }
    },
    deleteImageUrl() {
      this.imageData = null;
      this.imageUrl = "";
      this.imageUrlInputHandler();
      this.hideButtons = false;
    },
    previewImage(event) {
      this.imageError = false;
      let reader = new FileReader();
      
      reader.readAsDataURL(event.target.files[0] );
      reader.onload = evt => {
        let img = new Image();
        img.onload = () => {
          console.log(img.width,img.height)

          if (img.width > 1032 || img.height > 1032 || event.target.files[0].size > 10000000) {
            this.imageError = true;
          } else {
            this.hideButtons = true;
            this.uploadValue = 0;
            this.uploadImage = null;
            this.imageData = event.target.files[0];
            this.uploadImage = null;
                  console.log(this.imageData.name);

            const storageRef = firebase
              .storage()
              .ref(`${this.imageData.name + new Date().getTime()}`)
              .put(this.imageData);
            storageRef.on(
              `state_changed`,
              (snapshot) => {
                this.uploadValue =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              },
              (error) => {
                console.log(error.message);
              },
              () => {
                this.uploadValue = 100;
                storageRef.snapshot.ref.getDownloadURL().then((url) => {
                  this.uploadImage = url;
                  this.imageUrl = url;
                  console.log("uploadImage", this.uploadImage);
                  this.$emit("uploadImageResult", this.uploadImage);
                });
              }
            );
          }
        }
        img.src = evt.target.result;
      }
    },
    onUpload() {
      this.uploadImage = null;
      const storageRef = firebase
        .storage()
        .ref(`${this.imageData.name + new Date().getTime()}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.uploadImage = url;
            this.imageUrl = url;
            console.log("uploadImage", this.uploadImage);
            this.$emit("uploadImageResult", this.uploadImage);
          });
        }
      );
    },
    fillFormOnEdit() {
      console.log(this.startData);
      this.imageUrl = this.startData.ios_attachments.image;
      if (this.startData === null) {
        return;
      }
      if (this.imageUrl === null || this.imageUrl === "") {
        this.showImagePreview = false;
      } else {
        this.showImagePreview = true;
      }
    },
  },
  beforeMount() {
    this.fillFormOnEdit();
  },
};
</script>

<style scoped>
.fromItemContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  font-size: 13px;
  margin-bottom: 20px;
}
.file-select > .select-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 32px;
  border-radius: 4px;
  border: none;
  transition-duration: 0.4s;
  margin-right: 15px;
  border-radius: 4px;
  border: solid 1px #109cf1;
  background-color: rgba(16, 156, 241, 0.1);
  color: #109cf1;
  font-size: 14px;
}
.file-select > input[type="file"] {
  display: none;
}
#uploadImageContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}
#uploadImageInputContainer {
  margin-left: 15px;
  padding-left: 10px;
  width: 100%;
  height: 30px;
  margin-top: 2px;
  font-size: 14px;
  border: solid 1px #cbd4dc;
  border-radius: 5px;
  display: flex;
  align-items: center;
}
#uploadImageInput {
  width: 92%;
}
#addIcon {
  width: 24px;
  height: 24px;
}
#uploadImageButton {
  height: 32px;
  margin-right: 15px;
  border-radius: 4px;
  border: solid 1px #109cf1;
  background-color: rgba(16, 156, 241, 0.1);
  color: #109cf1;
  font-size: 14px;
}
#imageUrlPreviewContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  padding-right: 15px;
  padding-left: 15px;
}
#imagePreviewContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-top: 15px;
  color: #767675;
}
#imagePreview {
  width: 104px;
  height: 104px;
}
#imagePreviewInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  word-break: break-all;
  color: #767675;
}
#imageRestrictionsContainer {
  margin-top: 15px;
  display: flex;
  justify-content: space-evenly;
  color: #767675;
}
#restrictionData {
  font-weight: bold;
}
#uploadPreviewInfo {
  margin-left: 50px;
}
#uploadImageBtn {
  color: #109cf1;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}
#deleteImageBtn {
  margin-top:10px;
  color: #eb1e2f;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}
</style>